'use client'
import { useState } from 'react'
import Link from 'next/link'
import { useAuth } from '@/components/AuthProvider'
import { getSupabaseClient } from '@/lib/supabase/client'
import ThemeToggle from './ThemeToggle'

export default function SiteNav() {
  const { user, ready } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)
  //const displayEmail = isAuthed ? user!.email : null

  async function handleLogout() {
    try { await getSupabaseClient().auth.signOut() } catch {}
    window.location.assign('/login')
  }

  const isAuthed = ready && !!user
  const email = user?.email ?? null

  return (
    <header className="sticky top-0 z-40 border-b pb-1 bg-white/80 dark:bg-[#0b0f17]/70 backdrop-blur-md">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        {/* Brand */}
        <Link href="/" className="font-semibold text-gray-800 dark:text-white text-lg">

<span className="inline-flex items-center gap-2">
  <span className=" font-semibold tracking-wide">
    <span className="h1 text-gray-900 dark:text-white">ping</span>
    <span className="h1 text-blue-600">replies</span>
  </span>
  <span className="text-[10px] uppercase text-white-700">
    beta
  </span>
</span>

        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6 text-sm font-medium">
          {!isAuthed && (
            <>
              <Link href="/#features" className="hover:text-blue-600 dark:hover:text-blue-400">Features</Link>
              <Link href="/#pricing" className="hover:text-blue-600 dark:hover:text-blue-400">Pricing</Link>
              <Link href="/#testimonials" className="hover:text-blue-600 dark:hover:text-blue-400">Testimonials</Link>
              <Link href="/#faq" className="hover:text-blue-600 dark:hover:text-blue-400">FAQ</Link>
            </>
          )}
          {isAuthed && (
            <>
              <Link href="/dashboard" className="hover:text-blue-600 dark:hover:text-blue-400">Dashboard</Link>
              <Link href="/settings#connect" className="hover:text-blue-600 dark:hover:text-blue-400">Connect Google</Link>
              <Link href="/settings" className="hover:text-blue-600 dark:hover:text-blue-400">Settings</Link>
              <Link href="/settings#profile" className="hover:text-blue-600 dark:hover:text-blue-400">Profile</Link>
              <Link href="/settings/password" className="hover:text-blue-600 dark:hover:text-blue-400">Change Password</Link>
            </>
          )}
        </nav>

        {/* Right side (desktop) */}
        <div className="hidden md:flex items-center gap-3">
          <ThemeToggle />
          {isAuthed ? (
            <>
              <span className="hidden md:inline text-xs text-gray-600 dark:text-gray-300">{email}</span>
              <button
                onClick={handleLogout}
                className="px-3 py-1.5 rounded-lg text-sm font-medium bg-blue-600 text-white hover:brightness-110"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link href="/login" className="px-3 py-1.5 rounded-lg text-sm border hover:bg-black/5 dark:hover:bg-white/10">
                Log in
              </Link>
              <Link href="/signup" className="px-3 py-1.5 rounded-lg text-sm bg-blue-600 text-white hover:brightness-110">
                Get started
              </Link>
            </>
          )}
        </div>

        {/* Hamburger (mobile) */}
        <button
          className="md:hidden flex items-center justify-center p-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/10"
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle menu"
        >
          <svg className="h-6 w-6 text-gray-700 dark:text-gray-200" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="md:hidden bg-white dark:bg-[#0b0f17] border-t border-gray-200 dark:border-white/10 px-4 py-3 space-y-2">
          {isAuthed ? (
            <>
              <div className="text-xs opacity-70">Signed in as {email}</div>
              <Link href="/dashboard" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Dashboard</Link>
              <Link href="/settings#connect" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Connect Google</Link>
              <Link href="/settings" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Settings</Link>
              <Link href="/settings#profile" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Profile</Link>
              <Link href="/settings/password" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Change Password</Link>
              <button
                onClick={handleLogout}
                className="block w-full text-left py-1.5 text-red-600 dark:text-red-400"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link href="/#features" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Features</Link>
              <Link href="/#pricing" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Pricing</Link>
              <Link href="/#testimonials" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Testimonials</Link>
              <Link href="/#faq" className="block py-1.5" onClick={()=>setMenuOpen(false)}>FAQ</Link>
              <Link href="/login" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Log in</Link>
              <Link href="/signup" className="block py-1.5" onClick={()=>setMenuOpen(false)}>Get started</Link>
            </>
          )}
        </div>
      )}
    </header>
  )
}
